<template>
    <div>
        <van-nav-bar
            title="消息详情"
        />
        <van-cell-group>
            <van-cell title="店铺：" :value="shop_name" size="large" />
            <van-cell title="标题：" :value="title" size="large" />
            <van-cell title="开始日期：" :value="start_date" size="large" />
            <van-cell title="结束日期：" :value="end_date" size="large" />
            <van-cell title="说明：" :value="description" size="large" />
        </van-cell-group>
        <van-image v-if="image" width="100%" height="100%" :src="image" />
        <van-image v-if="image1" width="100%" height="100%" :src="image1" />
        <van-image v-if="image2" width="100%" height="100%" :src="image2" />
        <van-image v-if="image3" width="100%" height="100%" :src="image3" />
        <van-image v-if="image4" width="100%" height="100%" :src="image4" />
    </div>
</template>

<script>
import { NavBar, Button, Cell, CellGroup, Toast, Image as VanImage } from 'vant';
import { MessageApi } from '@/api/shop'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Toast.name]: Toast,
        [VanImage.name]: VanImage
    },
    data() {
        return {
            id: this.$route.params.id,
            shop_name:'',
            title:'',
            start_date:'',
            end_date:'',
            description:'',
            image:null,
            image1:null,
            image2:null,
            image3:null,
            image4:null,
            from:{}
        }
    },
    mounted(){
        this.getMessageDetail()
    },
    methods: {
        getMessageDetail(){
            var that = this
            that.axios.get(MessageApi+that.id+'/').then((ret) => {
                console.log(ret)
                that.shop_name = ret.shop_name
                that.title = ret.title
                that.start_date = ret.start_date
                that.end_date = ret.end_date
                that.description = ret.description
                that.image = ret.image
                that.image1 = ret.image1
                that.image2 = ret.image2
                that.image3 = ret.image3
                that.image4 = ret.image4
            })
        }
    }
}
</script>

<style lang="less" scoped>
</style>